import $ from "jquery";
import { gsap, Linear } from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);

const parallax = () => {
  //setup class
  const parallaxClass = ".js-parallax";
  const $parallaxTrigger = $(parallaxClass).prev();
  if ($parallaxTrigger.length === 0) {
    return;
  }
  const scrollHeight = $(parallaxClass).eq(0).height();
  $(parallaxClass).nextAll().addClass(parallaxClass.slice(1));
  $(parallaxClass)
    .parent()
    .nextAll()
    .not("script")
    .addClass(parallaxClass.slice(1));
  $("body").height($("body").height() - scrollHeight);

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: $parallaxTrigger,
      scrub: true,
      start: "bottom bottom",
      end: "+80%",
    },
  });
  tl.to($(parallaxClass), {
    y: -scrollHeight,
    duration: 10,
    ease: Linear.easeNone,
  });
};

const parallaxScroll = () => {

  const $parallaxScroll = $('.js-parallax-scroll');
  if ($parallaxScroll.length === 0) {
    return;
  }

  $parallaxScroll.find('.bg').css('overflow','hidden')
  const $item = $parallaxScroll.find('.bg img')
  $(window).on("scroll", function () {
    const offset = $parallaxScroll.offset().top;
    const scrollTop = $(window).scrollTop();
    const posX = Math.floor((scrollTop - offset) / 10);

    $item.css({ transform: `scale(1.25) translateZ(0) translateY(${posX}px)` });
  });
}

export {
  parallax,
  parallaxScroll
}
